/**
 * 페이지 상태와 URL 매핑을 관리하는 매니저
 */
export class PageManager<TPage extends string = string> {
  private page: TPage;

  constructor(
    page: TPage | undefined,
    private readonly defaultPage: TPage,
    private readonly pageUrlMap: Record<TPage, string>,
  ) {
    // 값이 없으면 기본값으로 초기화
    this.page = page ?? defaultPage;
  }

  setPage(page: TPage): this {
    this.page = page;
    return this;
  }

  getPage(): TPage {
    return this.page;
  }

  getPageName(): string {
    return this.page.toLowerCase();
  }

  /**
   * 현재 페이지에 해당하는 URL 패턴 반환
   */
  getPageUrl(lang: string): string {
    const urlPattern = this.pageUrlMap[this.page];
    return urlPattern.replace(':lang', lang);
  }

  isRanking(): boolean {
    return this.page === 'RANKING';
  }

  isProducts(): boolean {
    return this.page === 'PRODUCTS';
  }

  reset(): this {
    this.page = this.defaultPage;
    return this;
  }
}
